import { render, staticRenderFns } from "./OpenFieldEditor.vue?vue&type=template&id=1c829ea2&scoped=true"
import script from "./OpenFieldEditor.vue?vue&type=script&lang=js"
export * from "./OpenFieldEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c829ea2",
  null
  
)

export default component.exports